import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { ResourceZone } from "@app/models/rest/resource-zone";
import { ResourceZoneRestService } from "@app/services/hal/resource-zone-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class ResourceZoneStore extends RealTimeDataStore<ResourceZone> {
  constructor() {
    const resourceZoneRestService = inject(ResourceZoneRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(resourceZoneRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("ResourceZone");
  }
}
